import { ENDPOINTS } from "@api/endpoints";
import HttpClient from "@api/HttpClient";

import { SpotlightRes } from "types/responses";

export const getSpotlight = async (queryStr = ""): Promise<SpotlightRes> => {
  const res = await HttpClient.get(`${ENDPOINTS.search.spotlight}${queryStr}`);
  return res.data;
};
